module.exports = __webpack_public_path__ + "img/eight.c264fc44.png";